// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"686":"7b6ce516fa46b0c0","907":"5d44df2398ba3519"}[chunkId] + ".js";
};